import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { TextInput, Button, Label } from "flowbite-react";
import { atualizarUsuarioAction } from "../../actions/user";

const UserForm = ({ profile }) => {
  const dispatch = useDispatch();
  const { error } = useSelector((state) => state.user); // Pega o erro do Redux

  const [userForm, setUserForm] = useState({
    nome: profile?.nome || "",
    username: profile?.username || "",
    email: profile?.email || "",
    telefone: profile?.telefone || "",
    cpf: profile?.cpf || null,
  });

  const handleUserChange = (e) => {
    setUserForm({ ...userForm, [e.target.name]: e.target.value });
  };

  const handleSubmitUser = (e) => {
    e.preventDefault();
    dispatch(atualizarUsuarioAction(userForm));
  };

  return (
    <form className="mt-10 space-y-8" onSubmit={handleSubmitUser}>
      <h2 className="text-2xl font-semibold text-gray-700">
        Informações Pessoais
      </h2>
      {/* <div>
        <Label htmlFor="username">Nome de Usuário</Label>
        <TextInput
          id="username"
          name="username"
          type="text"
          value={userForm.username}
          onChange={handleUserChange}
          required
        />
      </div> */}
      <div>
        <Label htmlFor="nome">Nome</Label>
        <TextInput
          id="nome"
          name="nome"
          type="text"
          value={userForm.nome}
          onChange={handleUserChange}
        />
      </div>
      <div>
        <Label htmlFor="email">Email</Label>
        <TextInput
          id="email"
          name="email"
          type="email"
          value={userForm.email}
          onChange={handleUserChange}
          required
        />
      </div>
      <div>
        <Label htmlFor="telefone">Telefone</Label>
        <TextInput
          id="telefone"
          name="telefone"
          type="text"
          value={userForm.telefone}
          onChange={handleUserChange}
        />
      </div>
      {error && <p className="text-red-500 text-sm">{error}</p>}{" "}
      {/* Exibir erro */}
      <Button type="submit" gradientDuoTone="purpleToPink" className="w-full">
        Salvar Informações Pessoais
      </Button>
    </form>
  );
};

export default UserForm;
